export const SUBJECT_LABELS: Record<string, string> = {
  GET: 'Getallen',
  MET: 'Meten',
  SPR: 'Spelling',
  SWW: 'Spelling WW',
  TAA: 'Taal',
  TGL: 'Tijd & Geld',
  TOPO: 'Topografie',
  STU: 'Studievaardigheden',
}

export function timeAgo(ts: number | undefined | null): string {
  if (!ts) return '—'
  const diff = Date.now() - ts
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'zojuist'
  if (mins < 60) return `${mins}m geleden`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}u geleden`
  const days = Math.floor(hrs / 24)
  if (days < 30) return `${days}d geleden`
  return new Date(ts).toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'short',
  })
}

export function formatLastActive(ts: number | undefined | null): string {
  if (!ts) return '—'
  const diffH = (Date.now() - ts) / 3600000
  if (diffH < 1) return 'Zojuist'
  if (diffH < 24) return `${Math.round(diffH)}u geleden`
  return `${Math.round(diffH / 24)}d geleden`
}

export function formatDate(ts: number | undefined | null): string {
  if (!ts) return '—'
  return new Date(ts).toLocaleString('nl-NL', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
}
